import React, { useState, useEffect } from "react";
import { Drawer, IconButton, List } from "@material-ui/core";
import {
	Home as HomeIcon,
	Settings,
	VerifiedUser,
	Person as StudentiIcon,
	Timer as RitardoIcon,
	CalendarToday,
	ArrowBack as ArrowBackIcon,
	School,
	Euro,
	Description,
} from "@material-ui/icons";
import { useTheme } from "@material-ui/styles";
import { withRouter, useParams } from "react-router-dom";
import classNames from "classnames";
import Cookies from "universal-cookie";

// styles
import useStyles from "./styles";

// components
import SidebarLink from "./components/SidebarLink/SidebarLink";
import Dot from "./components/Dot";

// context
import { useLayoutState, useLayoutDispatch, toggleSidebar } from "../../context/LayoutContext";

function getIconFromType(type) {
	return <HomeIcon />;
}

function Sidebar({ location, ...props }) {
	var classes = useStyles();
	var theme = useTheme();

	//var props = useParams();

	// global
	var { isSidebarOpened } = useLayoutState();
	var layoutDispatch = useLayoutDispatch();

	// local
	var [isPermanent, setPermanent] = useState(true);

	useEffect(function() {
		window.addEventListener("resize", handleWindowWidthChange);
		handleWindowWidthChange();
		return function cleanup() {
			window.removeEventListener("resize", handleWindowWidthChange);
		};
	});

	//let menuItems = JSON.parse(props);

	let jsonItems = [];
	try {
		jsonItems = props.menuItems;
	} catch (error) {}

	let structure = [
		{ id: 1, label: "Corsi", link: "/billing/corsi", icon: <CalendarToday /> },
		{ id: 2, label: "Studenti", link: "/billing/studenti", icon: <StudentiIcon /> },
		{ id: 3, label: "Ritirati", link: "/billing/ritirati", icon: <StudentiIcon /> },
		{ id: 4, label: "Da verificare", link: "/billing/daVerificare", icon: <VerifiedUser /> },
		{ id: 5, label: "In ritardo", link: "/billing/inRitardo", icon: <RitardoIcon /> },
		// { id: 6, type: "divider" },
		// { id: 14, type: "title", label: "Regimi" },
		// { id: 9, label: "Showrestart", link: "/billing/fattureShowRestart", icon: <Description /> },
		// { id: 10, label: "Regime Forfettario", link: "/billing/fattureForfettari", icon: <Description /> },
		// { id: 11, label: "Regime Ordinario", link: "/billing/fattureOrdinari", icon: <Description /> },
		{ id: 12, type: "divider" },
		{ id: 15, label: "Sezione Admin", link: "/app/corsi", icon: <StudentiIcon /> },
		{ id: 13, label: "Impostazioni", link: "/billing/usersettings", icon: <Settings /> },
	];

	return (
		<Drawer
			variant={isPermanent ? "permanent" : "temporary"}
			className={classNames(classes.drawer, {
				[classes.drawerOpen]: isSidebarOpened,
				[classes.drawerClose]: !isSidebarOpened,
			})}
			classes={{
				paper: classNames({
					[classes.drawerOpen]: isSidebarOpened,
					[classes.drawerClose]: !isSidebarOpened,
				}),
			}}
			open={isSidebarOpened}
			style={{ position: "sticky" }}
		>
			<div className={classes.toolbar} />
			<div className={classes.mobileBackButton}>
				<IconButton onClick={() => toggleSidebar(layoutDispatch)}>
					<ArrowBackIcon
						classes={{
							root: classNames(classes.headerIcon, classes.headerIconCollapse),
						}}
					/>
				</IconButton>
			</div>
			<List className={classes.sidebarList}>
				<img
					src={require("../../images/loghi/bianco_trasparente.png")}
					style={{ position: "relative", width: "90%", border: "0px solid black", left: "5%" }}
				/>
				{structure.map(link => (
					<SidebarLink key={link.id} location={location} isSidebarOpened={isSidebarOpened} {...link} />
				))}
			</List>
		</Drawer>
	);

	// ##################################################################
	function handleWindowWidthChange() {
		var windowWidth = window.innerWidth;
		var breakpointWidth = theme.breakpoints.values.md;
		var isSmallScreen = windowWidth < breakpointWidth;

		if (isSmallScreen && isPermanent) {
			setPermanent(false);
		} else if (!isSmallScreen && !isPermanent) {
			setPermanent(true);
		}
	}
}

export default withRouter(Sidebar);
